/**
* Prevent submit if has error
*/

const orderFormSubmit = () => {
  const errors = document.querySelectorAll(".form__error");
  const submitBtn = document.querySelector<HTMLInputElement>('.js-order-submit-btn')
  
  if (!submitBtn) return;
  submitBtn.addEventListener("click", (e) => {
    errors.forEach(err => {
      if(err.classList.contains("show")) {
        e.preventDefault();
      }
    });

    let firstError:any = document.getElementsByClassName("form__error show")[0];
    if(!firstError) return;
    let errPos = firstError.getBoundingClientRect().top + window.pageYOffset + (-300)
    window.scrollTo({top: errPos, behavior: 'smooth'});
  })
}

export default orderFormSubmit
